(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sticky-atc"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {

// console.log("init sticky add to cart")

    const stickyAddToCart = document.getElementById('sticky-add-to-cart');
    const productElement = document.getElementById('product');

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          stickyAddToCart.classList.add('hidden');
        } else {
          stickyAddToCart.classList.remove('hidden');
        }
      });
    }, {threshold: 0.1});

    if (productElement) {
      observer.observe(productElement);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
